import FooterList from "./FooterList";

export default FooterList;
